import HelmetComp from '../../../../../components/helmet/Helmet';
import SuccessAction from '../../../../../components/successAction';
import { title } from '../../../../../utils/matchingTitle';

const CustomerSurveySuccess = () => {
  const props: any = {
    textDescription: (
      <>
        本日はご利用ありがとうございました。
        <br />
        お客様の生活が、より豊かになる様に
        <br />
        スタッフ一同努めてまいります。
        <br />
        引き続きよろしくお願いいたします。
      </>
    ),
    editCustomer: true,
    surveySuccess: true,
    isLogin: true,
  };

  return (
    <>
      <HelmetComp user title={title.customerSurveySuccess} />
      <SuccessAction {...props} />
    </>
  );
};

export default CustomerSurveySuccess;
